import { DomSanitizer } from '@angular/platform-browser';

/**
 * Sanitizes HTML content to prevent XSS attacks
 * Uses Angular's built-in DomSanitizer which is safe and doesn't require external dependencies
 */
export class HtmlSanitizerUtil {
  
  private static isZoomDomain(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }
    const hostname = window.location.hostname || '';
    return hostname.includes('zoomtest.onlinecoursehost.com');
  }
  
  /**
   * Sanitizes HTML content for display
   * For zoomtest domain: strips ALL HTML tags completely to prevent HTML injection and XSS
   * For other domains: returns HTML as-is
   */
  static sanitizeHtml(sanitizer: DomSanitizer, dirtyHtml: string): string {
    if (!dirtyHtml) {
      return '';
    }

    // Only sanitize for Zoom specific domain
    if (!this.isZoomDomain()) {
      return dirtyHtml; 
    }

    // For Zoom test domain: Strip ALL HTML tags using regex (no DOM parsing = no XSS execution)
    // This converts "<img src=x onerror='alert()'>" to "" (empty string)
    // or "<p>Hello <b>World</b></p>" to "Hello World" (plain text only)
    // Using regex instead of innerHTML to avoid executing scripts during sanitization
    return dirtyHtml.replace(/<[^>]*>/g, '').trim();
  }

  /**
   * Sanitizes HTML and returns SafeHtml for use with [innerHTML]
   * For zoomtest domain: strips ALL HTML and returns plain text
   * For other domains: bypasses security and returns HTML as-is
   */
  static sanitizeAndTrustHtml(sanitizer: DomSanitizer, dirtyHtml: string) {
    if (!this.isZoomDomain()) {
      return sanitizer.bypassSecurityTrustHtml(dirtyHtml);
    }
    
    // For Zoom test domain: strip ALL HTML tags and return plain text
    const plainText = this.sanitizeHtml(sanitizer, dirtyHtml);
    
    // Return plain text wrapped in a safe container
    // This ensures no HTML is rendered, only text
    return sanitizer.bypassSecurityTrustHtml(plainText);
  }
}
